import { useState, useEffect } from "react";
import api from "../../api";
import {toast} from "react-hot-toast";
import formatDuration from "../../utils/formatDuration"
import ToggleSwitch from "./ToggleSwitch"

export default function CityDeliveryRow({ city, warehouseId }) {
  const hasRecord = !!city.delivery_info;


  const [initialDays, setInitialDays] = useState(hasRecord ? city.delivery_info.duration_days : "")
  const [initialActive, setInitialActive] = useState(hasRecord ? city.delivery_info.is_active : false)

  const [days, setDays] = useState(initialDays);
  const [isActive, setIsActive] = useState(initialActive);
  const [loading, setLoading] = useState(false);
  const [isChanged, setIsChanged] = useState(false);

  // منطق بررسی تغییرات
  useEffect(() => {
    // تبدیل به رشته برای مقایسه دقیق
    const hasChanged = String(days) !== String(initialDays) || isActive !== initialActive;
    setIsChanged(hasChanged);
  }, [days, isActive, initialDays, initialActive]);

  const handleUpdate = async () => {
    if (days === "" || Number(days) < 0) {
      alert("لطفاً یک عدد معتبر برای روز وارد کنید");
      return;
    }

    setLoading(true);
    try {
      await api.post(`/operation/supplier-delivery/update/${warehouseId}/${city.id}/`, {
        duration_days: Number(days),
        is_active: isActive,
      });
      toast.success("تغییرات اعمال شد.");
      setInitialDays(Number(days));
      setInitialActive(isActive);
      setIsChanged(false); // ریست کردن وضعیت تغییر بعد از ذخیره موفق
    } catch (err) {
      console.error(err);
      alert("خطا در ثبت اطلاعات");
    } finally {
      setLoading(false);
    }
  };

  // چک باکس در صورتی فعال است که فیلدی برای روز وارد شده باشد (days != "")
  const isCheckboxDisabled = days === "" || days === null || Number(days) < 0;

  const distanceKm = city.delivery_info?.distance_km ?? city.distance_km ?? "-";
  const durationMinutes = city.delivery_info?.duration_minutes ?? city.duration_minutes ?? "-";

  return (
      <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg text-sm">
        <span className="w-24 font-medium">{city.name}</span>
        <div className="flex gap-4 text-xs text-gray-500">
          <span>مسافت: {distanceKm} km</span>
          <span>زمان سفر: {formatDuration(durationMinutes)} </span>
        </div>

        <div className="flex items-center gap-2">
          <input
              type="number"
              className="w-16 border rounded px-1"
              value={days}
              onChange={(e) => setDays(e.target.value)}
              placeholder="-"
              min="1"
          />
          <span className="text-gray-600">روز</span>

          <ToggleSwitch
            checked={isActive}
            onChange={(e) => setIsActive(e.target.checked)}
            disabled={isCheckboxDisabled}
          />

          <button
              onClick={handleUpdate}
              // دکمه تایید فقط در صورت وجود تغییر و معتبر بودن روز فعال است
              disabled={loading || !isChanged || isCheckboxDisabled}
              className={`px-3 py-1 rounded text-white ${
                  !isChanged || isCheckboxDisabled ? "bg-gray-400 cursor-not-allowed" : "bg-blue-900"
              }`}
          >
            {loading ? "..." : "تأیید"}
          </button>
        </div>
      </div>
  );
}
